// 차트 색 모듈.
// recharts는 CSS 변수가 아닌 실제 색 문자열(hex)을 fill/stroke로 받아야 하므로,
// app.css 의 시맨틱 토큰(:root, 라이트 기준)을 리터럴로 미러링한다.
// ⚠️ app.css 의 시맨틱 토큰과 반드시 동기화할 것(라이트 기준).
//   primary #2563eb · info #0ea5e9 · success #16a34a · warning #d97706
//   danger #dc2626 · point #db2777

export const KRDS = {
    primary: '#2563eb', // --primary (blue-600)
    primaryStrong: '#1d4ed8', // blue-700
    primarySoft: '#93b4fb', // 옅은 파랑
    success: '#16a34a', // --success
    warning: '#d97706', // --warning
    danger: '#dc2626', // --destructive
    info: '#0ea5e9', // info(파랑과 구분되는 sky)
    point: '#db2777', // --point
    secondary: '#64748b', // slate-500(중립 비교색)
    gray: {
        0: '#ffffff',
        5: '#fafafa', // --background
        10: '#e8e8ec', // 격자선 (--border)
        20: '#d4d4d8', // 보더 (--input)
        30: '#b1b8be',
        40: '#a1a1aa', // zinc-400
        50: '#71717a', // 축 텍스트 (--muted-foreground)
        60: '#52525b', // subtle text
        70: '#3f3f46', // zinc-700
        80: '#27272a',
        90: '#18181b', // text-basic (--foreground)
    },
} as const

// 차트 공통 기준선 색(격자·축·툴팁 보더).
export const CHART_GRID = KRDS.gray[10]
export const CHART_AXIS = KRDS.gray[50]
export const CHART_BORDER = KRDS.gray[20]

// 의미색 매핑 — 진행/완료/실패 등 상태를 일관되게.
//   진행=info, 완료/적합=success, 실패/이탈=danger, 대기=primarySoft, 경고=warning
export const STATUS_COLOR: Record<string, string> = {
    // 문서 파이프라인
    pending: KRDS.primarySoft,
    queued: KRDS.primarySoft,
    processing: KRDS.info,
    collecting: KRDS.info,
    scored: KRDS.primary,
    reported: KRDS.success,
    completed: KRDS.success,
    done: KRDS.success,
    success: KRDS.success,
    failed: KRDS.danger,
    error: KRDS.danger,
    rejected: KRDS.danger,
}

// 알 수 없는 상태는 중립 회색.
export function statusColor(key: string): string {
    return STATUS_COLOR[key] ?? KRDS.gray[40]
}

// 서비스별 활동량 등 범주형 비교용 팔레트(명료 우선).
export const CATEGORICAL = [
    KRDS.primary,
    KRDS.info,
    KRDS.secondary,
    KRDS.success,
    KRDS.warning,
    KRDS.point,
] as const

// recharts 툴팁 공통 스타일(흰 카드 + 보더).
export const tooltipStyles = {
    contentStyle: {
        background: KRDS.gray[0],
        border: `1px solid ${CHART_BORDER}`,
        borderRadius: 6,
        fontSize: 13,
        color: KRDS.gray[90],
        boxShadow: '0 1px 2px rgba(24,24,27,0.06)',
    } as const,
    labelStyle: { color: KRDS.gray[60], fontWeight: 600 } as const,
    itemStyle: { color: KRDS.gray[90] } as const,
    cursor: { fill: KRDS.gray[5] } as const,
}
